export const menuItems = [
  {
    path: "/",
    text: "home",
  },
  {
    path: "/products",
    text: "products",
  },
  {
    path: "/blogs",
    text: "blogs",
  },
  {
    path: "/contact",
    text: "contact",
  },
]
